import { z } from "zod";
import { Id, PageQuery } from "./common";
import { AssetStatus, MaintenanceState } from "./asset";
import { DeviceStatus, DeviceType } from "./device";
import { FacilityStatus, SiteType } from "./facility";
import { BoundaryState, OnlineState, RiskLevel } from "./state";

export const SortDirection = z.enum(["asc", "desc"]);
export type SortDirection = z.infer<typeof SortDirection>;

export const InventorySort = z.object({
  field: z.string().min(1).max(80),
  direction: SortDirection.default("asc"),
});
export type InventorySort = z.infer<typeof InventorySort>;

export const AssetListFilters = PageQuery.extend({
  search: z.string().min(1).max(120).optional(),
  siteId: Id.optional(),
  buildingId: Id.optional(),
  floorId: Id.optional(),
  status: AssetStatus.optional(),
  maintenanceState: MaintenanceState.optional(),
  riskLevel: RiskLevel.optional(),
  onlineState: OnlineState.optional(),
  boundaryState: BoundaryState.optional(),
  hasActiveAlerts: z.coerce.boolean().optional(),
  sortField: z.string().min(1).max(80).optional(),
  sortDirection: SortDirection.optional(),
});
export type AssetListFilters = z.infer<typeof AssetListFilters>;

export const DeviceListFilters = PageQuery.extend({
  search: z.string().min(1).max(120).optional(),
  siteId: Id.optional(),
  assetId: Id.optional(),
  deviceType: DeviceType.optional(),
  status: DeviceStatus.optional(),
  maintenanceState: MaintenanceState.optional(),
  riskLevel: RiskLevel.optional(),
  onlineState: OnlineState.optional(),
  hasActiveAlerts: z.coerce.boolean().optional(),
  sortField: z.string().min(1).max(80).optional(),
  sortDirection: SortDirection.optional(),
});
export type DeviceListFilters = z.infer<typeof DeviceListFilters>;

export const SiteListFilters = PageQuery.extend({
  search: z.string().min(1).max(120).optional(),
  siteType: SiteType.optional(),
  status: FacilityStatus.optional(),
  riskLevel: RiskLevel.optional(),
  hasActiveAlerts: z.coerce.boolean().optional(),
  hasStaleDevices: z.coerce.boolean().optional(),
  sortField: z.string().min(1).max(80).optional(),
  sortDirection: SortDirection.optional(),
});
export type SiteListFilters = z.infer<typeof SiteListFilters>;

export const RegistryOverview = z.object({
  tenantId: Id,
  siteCount: z.number().int().min(0),
  assetCount: z.number().int().min(0),
  deviceCount: z.number().int().min(0),
  activeAlertCount: z.number().int().min(0),
  openWorkItemCount: z.number().int().min(0),
  staleDeviceCount: z.number().int().min(0),
});
export type RegistryOverview = z.infer<typeof RegistryOverview>;
